import { create } from 'zustand';

interface AssignClientState {
    subAccountRefresh: boolean;
    setSubAccountRefresh: (open: boolean) => void;
}

// Create the Zustand store with types
const subAccountRefreshStore = create<AssignClientState>((set) => ({
    subAccountRefresh: false,
    setSubAccountRefresh: (open: boolean) => set({ subAccountRefresh: open }),
}));

export default subAccountRefreshStore;
